import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-t border-electric/10 bg-navy py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-19" data-mp="1yeb4ckorj8qr">
      <div className="mx-auto max-w-4xl px-4" data-id="element-20" data-mp="1ao7av65agpdh">
        <SectionHeading id="bonus-title" data-id="element-21" data-mp="1aoz101g49uwd">The {totalBonuses} Exclusive Bonuses</SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-electric/25 bg-panel shadow-lg shadow-black/30" data-id="element-22" data-mp="15qxh5eav9rju">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-electric/15 p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="1eor9ke5ig11q" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-electric/40 bg-navy text-electric" data-id="element-24" data-mp="2jhwcib4ylwdb">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-25" data-mp="2ofo4141ozggz" />
                </span>
                <div data-id="element-26" data-mp="1qu0ff5bha2g0">
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-electric" data-id="element-27" data-mp="1qus2tsux8tv7">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-bold leading-tight text-white" data-id="element-28" data-mp="1vuegg3enwc4j">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-ink" data-id="element-29" data-mp="20thnfte7csf5">{bonus.description}</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-gold bg-panel px-6 py-6 text-center shadow-lg shadow-black/40 sm:flex-row sm:text-left" data-id="element-30" data-mp="3c5ihnntu592a">
          <div data-id="element-31" data-mp="1h2cbjhb596pq">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-ink" data-id="element-32" data-mp="1h1u5jsyoje4m">Value of all {totalBonuses} bonuses</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-ink line-through decoration-electric decoration-2" data-id="element-33" data-mp="1c6ev7azvs0cy">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-34" data-mp="1m303c5775rl0">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-ink" data-id="element-35" data-mp="ycnv0t81hstw">Your price today</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-gold" data-id="element-36" data-mp="te2vyx4ixf71">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-37" data-mp="175r6wx31dxmf" /> FREE
            </p>
          </div>
        </div>
      </div>
    </section>;
}